/* KAD added this Friday Aug 22, 2025 to make it easier to set colors throughout the app be consistent */
import { createTheme } from '@mui/material/styles';

const myCustomTheme = createTheme({
  palette: {
    //primary: {
    //  main: '#FF5733', // A bright orange
    //},
    //secondary: {
    //  main: '#33C4FF', // A bright blue
    //},
    // You can also override other colors like 'error', 'warning', etc.
    // info: {
    //   main: '#C333FF',
    // },
  },
 components: {
    MuiSvgIcon: {
      styleOverrides: {
        // The `root` slot targets the outermost element of the SvgIcon component
        root: {
          color: 'white',
        },
      },
    },
    // Optional: You can also set styles for the IconButton if you want its default icon color to be white
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: 'white',
        },
      },
    },
  }
});

export default myCustomTheme;
